import { z } from 'zod';
import { CalendarDate, WorkflowCategory, WorkloadDay } from './project.js';
/**
 * View điều phối cho PM/team lead — spec mục 3 và 16.
 *
 * ## Hai kiểu dữ liệu ở file này KHÔNG cùng độ nhạy cảm
 *
 * `TeamWorkloadView` cộng dồn tải **xuyên mọi project**, kể cả những project
 * người gọi không được vào. Nó an toàn duy nhất vì chỉ chứa **con số** — đúng
 * cùng luật với `WorkloadDay`. Thêm một trường chuỗi nào vào đây (tiêu đề task,
 * tên project) là mở đường rò dữ liệu chéo đi vòng qua row-level filter.
 *
 * `AssignmentMatrixView` thì ngược lại: nó chỉ nói về **một** project mà người
 * gọi đã được vào, nên có mã task và tên người là bình thường — cùng lượng
 * thông tin mà board đã hiển thị, chỉ sắp xếp khác.
 *
 * Đừng gộp hai thứ này thành một endpoint "cho tiện".
 */
/** Tải của một người trong khoảng đang xem. Chỉ số, không có tên việc. */
export const TeamMemberWorkload = z.object({
    userId: z.uuid(),
    /**
     * Tên người thì được — họ là thành viên của chính project người gọi đang
     * xem, nên tên đã hiện ở board và danh sách thành viên rồi.
     */
    displayName: z.string(),
    days: z.array(WorkloadDay),
    /** Số ngày vượt capacity — để sắp xếp và tô cảnh báo mà không phải quét lại. */
    overloadedDayCount: z.number().int().nonnegative(),
    /** Tổng giờ đã cam kết trong khoảng, dùng để so giữa các thành viên. */
    totalCommittedHours: z.number().nonnegative(),
});
export const TeamWorkloadView = z.object({
    from: CalendarDate,
    to: CalendarDate,
    members: z.array(TeamMemberWorkload),
});
// ─────────────────────────────────────────────────────────────────────────────
/** Một ô của ma trận: người × cột trạng thái, trong đúng một project. */
export const MatrixCell = z.object({
    statusId: z.uuid(),
    count: z.number().int().nonnegative(),
    estimateHours: z.number().nonnegative(),
});
export const MatrixRow = z.object({
    /** `null` = hàng "chưa giao ai" — chỗ dễ bị bỏ quên nhất khi cân đối. */
    userId: z.uuid().nullable(),
    displayName: z.string().nullable(),
    cells: z.array(MatrixCell),
    totalCount: z.number().int().nonnegative(),
    totalEstimateHours: z.number().nonnegative(),
});
export const AssignmentMatrixView = z.object({
    statuses: z.array(z.object({ id: z.uuid(), name: z.string(), category: WorkflowCategory })),
    rows: z.array(MatrixRow),
});
//# sourceMappingURL=coordination.js.map